import { Trans } from 'react-i18next'
import { useBoolean } from 'react-use'

import { ConditionFeatureFlag, ConditionTextOperator } from '@makyoapp/makyo-common'
import { Column16, Text16 } from '@makyoapp/makyo-icon/icon'

import { VariableWrapper } from '../VariableSelectV2/VariableWrapper'
import { useConditionRepeaterContext } from './ConditionRepeaterContext'
import { useConditionSelectContext } from './ConditionSelectContext'

export function ConditionPageContentDD() {
  const { id, setOpen, isRhs, index } = useConditionSelectContext()
  const { onChange, value } = useConditionRepeaterContext()
  const [show, setShow] = useBoolean(false)
  const key = isRhs ? 'rhs' : 'lhs'

  return (
    <VariableWrapper
      id={id ? `${id}-page-content` : undefined}
      show={show}
      setShow={setShow}
      title={<Trans>Page Content</Trans>}
      icon={<Column16 width={16} height={16} />}
    >
      <div className='flex flex-col'>
        {[
          { flag: ConditionFeatureFlag.PageContent, label: 'Name', icon: <Text16 /> },
          { flag: ConditionFeatureFlag.PageContent, label: 'Title', icon: <Text16 /> },
          { flag: ConditionFeatureFlag.PageContent, label: 'Sub title', icon: <Text16 /> },
          { flag: ConditionFeatureFlag.PageContent, label: 'Description', icon: <Text16 /> },
        ].map(({ flag, label, icon }) => (
          <button
            key={label}
            className='gap-2 sdd-item'
            onClick={() => {
              const nextCond = [...value.conditions]
              nextCond[index] = {
                ...nextCond[index],
                [key]: { flag, value: label },
                operator: ConditionTextOperator.IsNotEmpty,
              }
              onChange?.({ isAny: value.isAny, conditions: nextCond })
              setShow(false)
              setOpen(false)
            }}
          >
            {icon} {label}
          </button>
        ))}
      </div>
    </VariableWrapper>
  )
}

export function ConditionPageContentStatement({ statement }: { statement: any }) {
  return <span>Page Content: {statement.value}</span>
}
